export default __webpack_public_path__ + "static/media/medical_services.d23247fa.svg";